import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { trpc } from '@/lib/trpc';
import { useTranslation } from 'react-i18next';
import { BRAIN_CLIENTS } from '../../../../shared/types/brain';

function formatClientName(id: string): string {
  return BRAIN_CLIENTS[id] ?? id.charAt(0).toUpperCase() + id.slice(1);
}

interface ClientSelectorProps {
  value: string | null;
  onChange: (v: string) => void;
  /** Lock the selector (e.g. while viewing a persisted conversation). */
  disabled?: boolean;
}

export function ClientSelector({ value, onChange, disabled }: ClientSelectorProps) {
  const { data, isLoading } = trpc.brain.listClients.useQuery();
  const { t } = useTranslation();
  const clients = data?.clients ?? [];

  return (
    <Select value={value ?? ''} onValueChange={onChange} disabled={disabled || isLoading || clients.length === 0}>
      <SelectTrigger className="w-44 h-9 text-sm" aria-label={t('brain.selector.clients_label')}>
        <SelectValue placeholder={isLoading ? t('brain.selector.loading') : t('brain.selector.placeholder')} />
      </SelectTrigger>
      <SelectContent>
        {clients.map((id) => (
          <SelectItem key={id} value={id}>
            {formatClientName(id)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
